"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.913 5H5.087C4.21 5 3.5 5.702 3.5 6.568v10.864c0 .866.71 1.568 1.587 1.568h13.826c.876 0 1.587-.702 1.587-1.568V6.568C20.5 5.702 19.79 5 18.913 5zm-.413 7h-7V7h7v5z" }), "Banner");
//# sourceMappingURL=Banner.js.map